import styled from "styled-components";

import PhoneFrame from "src/assets/images/phone_frame.webp";

// phone_frame.webp 은 화면 부분이 투명하게 뚫린 휴대폰 테두리다. 실제 앱 캡처를 그 밑에 깔아서 보여준다.
// 아래 좌표는 모두 테두리 원본 크기(1540x3200) 기준이다. 화면에는 비율(%)로만 쓰이므로,
// 실제로 싣는 파일은 원본을 절반(770x1600, 화면에 그려지는 최대 크기의 2배)으로 줄인 것이어도 그대로 맞는다.
const FRAME = { width: 1540, height: 3200 };
// 캡처가 놓이는 영역. 뚫린 화면(65,52 ~ 1473,3146 / 모서리 반지름 143)보다
// 사방 6px 씩 넓게 잡아 캡처 가장자리가 테두리 밑으로 들어가게 한다.
const SCREEN = { left: 59, top: 46, width: 1420, height: 3106, radius: 149 };
// 캡처 밑에 까는 검은 바탕. 휴대폰이 작게 그려질 때 캡처와 테두리 사이에 1px 틈이 생겨도
// 페이지 색이 아니라 테두리와 같은 검은색이 보이게 한다. (테두리의 불투명한 부분 안쪽에 완전히 가려진다)
const BACKING = { left: 43, top: 30, width: 1452, height: 3137, radius: 165 };

const toBox = ({ left, top, width, height, radius }: typeof SCREEN) => `
  top: ${(top / FRAME.height) * 100}%;
  left: ${(left / FRAME.width) * 100}%;
  width: ${(width / FRAME.width) * 100}%;
  height: ${(height / FRAME.height) * 100}%;
  border-radius: ${(radius / width) * 100}% / ${(radius / height) * 100}%;
`;

interface PhoneMockupProps {
  src: string;
  alt: string;
  width?: number;
}

function PhoneMockup({ src, alt, width = 385 }: PhoneMockupProps) {
  return (
    <S.Phone $width={width}>
      <S.Backing />
      <S.Screen src={src} alt={alt} />
      <S.Frame src={PhoneFrame} alt="" />
    </S.Phone>
  );
}

export default PhoneMockup;

const S = {
  Phone: styled.div<{ $width: number }>`
    position: relative;
    flex-shrink: 0;
    width: ${({ $width }) => $width}px;
    height: ${({ $width }) => ($width * FRAME.height) / FRAME.width}px;
  `,
  Backing: styled.div`
    position: absolute;
    ${toBox(BACKING)}
    background: #000000;
  `,
  Screen: styled.img`
    position: absolute;
    ${toBox(SCREEN)}
    object-fit: cover;
  `,
  Frame: styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `,
};
